<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
    <g>
    	<g>
    		<path d="M505.418,34.829c-1.288-1.529-3.131-2.484-5.123-2.654l-111.428-9.517L386.847,6.6c-0.52-4.131-4.299-7.059-8.42-6.54    L275.06,13.056c-0.407-0.106-0.824-0.186-1.258-0.223L131.726,0.697c-4.091-0.36-7.805,2.786-8.153,6.869l-2.118,24.8    L11.406,46.202c-4.072,0.512-7.051,4.345-6.54,8.42L61.04,501.43c0.255,2.038-0.182,3.996,0.651,5.967    c1.168,2.761,3.948,4.604,6.947,4.604h369.909c4.165,0,7.539-3.374,7.539-7.539v-9.819l14.601,1.247    c4.091,0.355,7.805-2.784,8.153-6.869L507.163,40.33C507.334,38.337,506.707,36.359,505.418,34.829z M61.099,381.023    L20.768,60.221l40.331-5.07V381.023z M137.955,16.362l65.98,5.635l-67.182,8.447L137.955,16.362z M372.828,15.961l3.852,30.637    H129.129L372.828,15.961z M454.459,480.225l-8.373-0.715V259.195c0-4.164-3.374-7.539-7.539-7.539s-7.539,3.374-7.539,7.539    v237.727H76.177V61.676h354.832v162.338c0,4.165,3.374,7.539,7.539,7.539s7.539-3.374,7.539-7.539V54.137    c0-4.164-3.374-7.539-7.539-7.539h-46.671l-1.087-8.643l100.709,8.602L454.459,480.225z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M398.34,86.806h-40.208c-2.521,0-4.875,1.259-6.272,3.357l-17.064,25.596c-18.367-13.157-40.854-20.912-65.12-20.912    c-4.164,0-7.539,3.374-7.539,7.539v104.54c0,4.164,3.374,7.539,7.539,7.539h104.54c4.165,0,7.539-3.374,7.539-7.539    c0-32.097-13.566-61.081-35.26-81.533l15.673-23.509h36.173c4.164,0,7.539-3.374,7.539-7.539S402.504,86.806,398.34,86.806z     M366.387,199.387h-89.172v-89.172c18.283,1.412,35.15,7.932,49.206,18.107l-6.727,10.091c-2.101,3.15-1.485,7.513,1.417,9.95    c3.398,2.854,8.669,2.101,11.128-1.586l5.757-8.636C354.025,154.063,364.543,175.527,366.387,199.387z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M398.34,336.092h-68.195l-12.016-19.225c19.465-20.17,31.459-47.598,31.459-77.775c0-4.165-3.374-7.539-7.539-7.539    h-97.001v-97.001c0-4.164-3.375-7.539-7.539-7.539c-61.8,0-112.079,50.279-112.079,112.079c0,61.8,50.279,112.079,112.079,112.079    c26.123,0,50.185-8.984,69.264-24.023l12.8,20.48c1.378,2.204,3.794,3.543,6.393,3.543h72.374c4.164,0,7.539-3.374,7.539-7.539    S402.504,336.092,398.34,336.092z M292.153,275.304c-2.206-3.533-6.859-4.605-10.389-2.398c-3.531,2.206-4.605,6.858-2.398,10.389    l19.364,30.982c-16.709,13.631-38.026,21.817-61.22,21.817c-53.486,0-97.001-43.515-97.001-97.001    c0-50.95,39.485-92.851,89.462-96.711v96.711c0,4.164,3.375,7.539,7.539,7.539h96.711c-1.684,21.801-10.608,41.604-24.362,57.004    L292.153,275.304z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M173.177,376.3h-64.332c-4.163,0-7.539,3.374-7.539,7.539s3.375,7.539,7.539,7.539h64.332    c4.164,0,7.539-3.374,7.539-7.539S177.341,376.3,173.177,376.3z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M269.676,376.3h-64.332c-4.164,0-7.539,3.374-7.539,7.539s3.375,7.539,7.539,7.539h64.332    c4.164,0,7.539-3.374,7.539-7.539S273.84,376.3,269.676,376.3z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M213.385,416.508h-104.54c-4.163,0-7.539,3.374-7.539,7.539c0,4.165,3.375,7.539,7.539,7.539h104.54    c4.164,0,7.539-3.374,7.539-7.539C220.924,419.882,217.548,416.508,213.385,416.508z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M269.676,416.508h-24.125c-4.163,0-7.539,3.374-7.539,7.539c0,4.165,3.375,7.539,7.539,7.539h24.125    c4.164,0,7.539-3.374,7.539-7.539C277.214,419.882,273.84,416.508,269.676,416.508z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M141.011,456.715h-32.166c-4.163,0-7.539,3.374-7.539,7.539s3.375,7.539,7.539,7.539h32.166    c4.164,0,7.539-3.374,7.539-7.539S145.175,456.715,141.011,456.715z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M269.676,456.715h-96.498c-4.163,0-7.539,3.374-7.539,7.539s3.375,7.539,7.539,7.539h96.498    c4.164,0,7.539-3.374,7.539-7.539S273.84,456.715,269.676,456.715z"/>
    	</g>
    </g>
  </svg>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
</style>
